import { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { ThumbsUp, ThumbsDown, Send, Check } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function ToolFeedback({ tool }) {
  const [rating, setRating] = useState(null);
  const [comment, setComment] = useState('');
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);

  const submit = async (r) => {
    const chosen = r || rating;
    if (!chosen || sending) return;
    setSending(true);
    try {
      await fetch(`${API_URL}/api/tool-feedback`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ rating: chosen, comment: comment.trim(), tool }),
      });
    } catch (_) { /* non-blocking */ }
    setSent(true);
    setSending(false);
  };

  if (sent) {
    return (
      <div data-testid="tool-feedback-thanks" className="flex items-center justify-center gap-2 py-4 text-sm text-muted-foreground">
        <Check className="w-4 h-4 text-green-500" />
        <span>Gracias por tu opinión</span>
      </div>
    );
  }

  return (
    <div data-testid="tool-feedback" className="border-t border-border/40 pt-4 mt-6">
      <p className="text-sm text-muted-foreground text-center mb-3">¿Te ha servido Klarvi?</p>
      <div className="flex items-center justify-center gap-3">
        <Button
          data-testid="feedback-positive"
          variant={rating === 'positivo' ? 'default' : 'outline'}
          size="sm"
          onClick={() => setRating('positivo')}
          className="gap-1.5"
        >
          <ThumbsUp className="w-4 h-4" /> Sí
        </Button>
        <Button
          data-testid="feedback-negative"
          variant={rating === 'negativo' ? 'default' : 'outline'}
          size="sm"
          onClick={() => setRating('negativo')}
          className="gap-1.5"
        >
          <ThumbsDown className="w-4 h-4" /> No
        </Button>
      </div>
      {rating && (
        <div className="flex items-center gap-2 mt-3 max-w-md mx-auto animate-in fade-in slide-in-from-top-2 duration-200">
          <Input
            data-testid="feedback-comment"
            placeholder="Comentario opcional..."
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && submit()}
            className="h-9 text-sm"
            maxLength={500}
          />
          <Button
            data-testid="feedback-submit"
            size="sm"
            onClick={() => submit()}
            disabled={sending}
            className="h-9 px-3"
          >
            <Send className="w-3.5 h-3.5" />
          </Button>
        </div>
      )}
    </div>
  );
}
